import { createContext } from "react";

export type NotificationData =
  | {
      loading: true;
    }
  | {
      loading: false;
      recentUnprocessedTranscripts: {
        totalCount: number;
      };
    };

export type NotificationContextType = {
  data: NotificationData;
  refetch: () => void;
};

export const NotificationContext = createContext<
  NotificationContextType | undefined
>(undefined);
